import { BandeauBenefices } from '@components/bandeau-benefices/models';
import { Block } from '@shared/models';

export const bandeauBeneficesMock: Block<BandeauBenefices> = {
  type: 'bandeau-benefices',
  data: {
    text: `Tout pour me décider en 1 rendez-vous !`,
    pictos: [
      {
        svg: '/assets/tmp/store.svg',
      },
      {
        svg: '/assets/tmp/store.svg',
      },
      {
        svg: '/assets/tmp/store.svg',
      },
    ],
  },
};
